<footer>
  <ul>
    <li>
      <a href="https://gnvert.engie-solutions.com/qui-sommes-nous" target="_blank" translate="footer.about_us"></a>
    </li>
    <li>
      <a href="https://gnvert.engie-solutions.com/tarifs/" target="_blank" translate="footer.rates"></a>
    </li>
    <li>
      <a href="https://gnvert.engie-solutions.com/contact/" target="_blank" translate="footer.contact"></a>
    </li>
    <li>
      <a href="/documents/Mentions%20légales%20-%20GNVERT.pdf" target="_blank" translate="footer.legal"></a>
    </li>
    <li>
      <a
        href="https://gnvert.engie-solutions.com/politique-de-confidentialite/"
        target="_blank"
        translate="footer.personal_data"
      ></a>
    </li>
    <li>
      <a href="https://gnvert.engie-solutions.com/cookies/" target="_blank" translate="footer.cookies"></a>
    </li>
  </ul>
</footer>
